import { FC } from 'react';
import { urls } from '@getstream/ui-library/build';

import { Product } from '../../../types/tour';

import styles from './Footer.module.css';

export type Props = {
  product: Product.Chat | Product.ActivityFeeds | Product.Video;
};

const labels = {
  chat: [
    ['Chat Messaging Documentation', urls.chat.docs],
    ['Chat Pricing', urls.chat.pricing],
  ],
  'activity-feeds': [
    ['Activity Feeds Documentation', urls.feeds.docs],
    ['Activity Feeds Pricing', urls.feeds.pricing],
  ],
  video: [
    ['Video Documentation', urls.video.docs],
    ['Video Pricing', urls.video.pricing],
  ],
};

export const Footer: FC<Props> = ({ product }) => {
  return (
    <div className={styles.footer}>
      <div>
        <span>© Stream.IO, Inc. All Rights Reserved.</span>
      </div>
      <ul className={styles.links}>
        {labels[product].map(([label, to], key) => (
          <li key={`${product}-${key}`}>
            <a href={to}>{label}</a>
          </li>
        ))}
        <li>
          <a href={urls.contact}>Contact Us</a>
        </li>
      </ul>
    </div>
  );
};
